import { gql } from '__generated__';

export default gql(`
  query GetParticipantOrders($project_id: ID!, $participant_id: ID!) {
    project(id: $project_id) {
      id
      participant(id: $participant_id) {
        id
        active
        orders {
          id
          invoice_date
          draft
          invoice_id
          amount
          balance
          remaining_amount
          refunded_amount
          cancelled
          waitlist
          preregistration
          deletable
          tickets_count
          created_at
          event {
            id
            title
          }
        }
      }
    }
  }
`);
